<ng-container [formGroup]="$any(controlContainer?.control)">
    <wdx-form-field
        [label]="formElement?.label | translateTokenisedString"
        [guidanceText]="formElement?.guidanceText | translateTokenisedString"
    >
    </wdx-form-field>
</ng-container>
